import React, { useState, useEffect } from 'react';
import '../styles/ImageCarousel.css';

// الصور من المجلد التي ليست pottery
const images = [
    '1280x960.jpg',
    '333353.jpg',
    '405513.jpg',
    '405516.jpg',
    '469745297_18470805526007130_3791869722863911074_n.jpg',
    '502672803_18504050419007130_3883543075010412041_n.jpg',
    'download.webp'
];

const ImageCarousel = ({ currentLang }) => {
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % images.length);
        }, 4000);
        return () => clearInterval(interval);
    }, []);

    const goToSlide = (index) => {
        setCurrentSlide(index);
    };

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % images.length);
    };

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + images.length) % images.length);
    };

    const getImageSrc = (imgName) => {
        // نفس الطريقة المستخدمة في PotteryCollection و PotteryModal
        const publicUrl = process.env.PUBLIC_URL || '';
        return publicUrl ? `${publicUrl}/${imgName}` : `/${imgName}`;
    };

    // حساب transform - في RTL نحتاج لعكس الاتجاه
    const getTransform = () => {
        const translateValue = -currentSlide * 100;
        return `translateX(${translateValue}%)`;
    };

    return (
        <section className="gallery-section">
            <h2 className="section-title">
                {currentLang === 'ar' ? 'معرض الفنان' : 'Artist Gallery'}
            </h2>
            <div className="image-carousel">
                <div className="carousel-container">
                    <div 
                        className="carousel-track"
                        style={{ transform: getTransform() }}
                    >
                        {images.map((img, index) => {
                            const imageSrc = getImageSrc(img);
                            return (
                                <div key={index} className="carousel-slide">
                                    <img 
                                        src={imageSrc}
                                        alt={`${currentLang === 'ar' ? 'فن الخزف' : 'Pottery Art'} ${index + 1}`}
                                        className="carousel-image"
                                        loading="eager"
                                        onError={(e) => {
                                            console.error('Image failed:', img, 'Path:', imageSrc);
                                            // محاولة مسار بديل
                                            const altPath = `/${img}`;
                                            if (!e.target.src.includes(altPath)) {
                                                e.target.src = altPath;
                                            }
                                        }}
                                        onLoad={() => {
                                            console.log('Image loaded:', img);
                                        }}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>
                <button className="carousel-btn carousel-prev" onClick={prevSlide}>‹</button>
                <button className="carousel-btn carousel-next" onClick={nextSlide}>›</button>
                <div className="carousel-dots">
                    {images.map((_, index) => (
                        <button
                            key={index}
                            className={`carousel-dot ${index === currentSlide ? 'active' : ''}`}
                            onClick={() => goToSlide(index)}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ImageCarousel;
